import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-brisanje-dijagnoze',
  templateUrl: './brisanje-dijagnoze.component.html',
  styleUrls: ['./brisanje-dijagnoze.component.css']
})
export class BrisanjeDijagnozeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
